import Provider from './AutoScrollProvider';

export default Provider;
